"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Highway = void 0;
var axios_1 = __importDefault(require("axios"));
var constants_1 = require("../common/constants");
var errors_1 = require("../common/errors");
var Client_1 = require("./Client");
var Plan_1 = require("./Plan");
var Project_1 = require("./Project");
var Route_1 = require("./Route");
var Service_1 = require("./Service");
var Vehicle_1 = require("./Vehicle");
var Webhook_1 = require("./Webhook");
var Highway = /** @class */ (function () {
    function Highway(apiKey, options) {
        var _this = this;
        this._request = function (method, url, data, headers) { return __awaiter(_this, void 0, void 0, function () {
            var error_1, _a, data_1, status_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 5, , 6]);
                        if (!data) return [3 /*break*/, 2];
                        return [4 /*yield*/, method(this.apiEndpoint + "/api/" + constants_1.API_VERSION + "/" + url, data || {}, {
                                params: __assign(__assign({}, (this._apiKey ? { private_key: this._apiKey } : {})), (this.queryParams ? this.queryParams : {})),
                                headers: __assign(__assign({}, headers), (!this._apiKey ? { Authorization: "Bearer " + this._token } : {})),
                            })];
                    case 1: return [2 /*return*/, (_b.sent()).data];
                    case 2: return [4 /*yield*/, method(this.apiEndpoint + "/api/" + constants_1.API_VERSION + "/" + url, {
                            params: __assign(__assign({}, (this._apiKey ? { private_key: this._apiKey } : {})), (this.queryParams ? this.queryParams : {})),
                            headers: __assign(__assign({}, headers), (!this._apiKey ? { Authorization: "Bearer " + this._token } : {})),
                        })];
                    case 3: return [2 /*return*/, (_b.sent()).data];
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        error_1 = _b.sent();
                        if (error_1.code === "ENOTFOUND" || error_1.code === "ECONNREFUSED") {
                            throw new errors_1.HighwayError(error_1.code + " - api endpoint is not correctly set", "highway.bad_endpoint", 0);
                        }
                        _a = error_1.response, data_1 = _a.data, status_1 = _a.status;
                        throw new errors_1.HighwayError(status_1 + " - " + data_1.message, data_1.messageId, status_1);
                    case 6: return [2 /*return*/];
                }
            });
        }); };
        this.post = function (url, data, headers) {
            if (data === void 0) { data = {}; }
            if (headers === void 0) { headers = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, this._request(axios_1.default.post, url, data, headers)];
                });
            });
        };
        this.get = function (url, headers) {
            if (headers === void 0) { headers = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, this._request(axios_1.default.get, url, undefined, headers)];
                });
            });
        };
        this.delete = function (url, headers) {
            if (headers === void 0) { headers = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, this._request(axios_1.default.delete, url, undefined, headers)];
                });
            });
        };
        this.put = function (url, data, headers) {
            if (data === void 0) { data = {}; }
            if (headers === void 0) { headers = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, this._request(axios_1.default.put, url, data, headers)];
                });
            });
        };
        this._token = options.bearer;
        this._apiKey = apiKey;
        this.project = new Project_1.Project(this);
        this.client = new Client_1.Client(this);
        this.webhook = new Webhook_1.Webhook(this);
        this.plan = new Plan_1.Plan(this);
        this.route = new Route_1.Route(this);
        this.service = new Service_1.Service(this);
        this.vehicle = new Vehicle_1.Vehicle(this);
        this.apiEndpoint = options.apiEndpoint || constants_1.HIGHWAY_ENDPOINT;
        this.queryParams = options.queryParams;
    }
    Object.defineProperty(Highway.prototype, "apiKey", {
        get: function () {
            return this._apiKey;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Highway.prototype, "token", {
        get: function () {
            return this._token;
        },
        enumerable: false,
        configurable: true
    });
    return Highway;
}());
exports.Highway = Highway;
//# sourceMappingURL=Highway.js.map